export default __webpack_public_path__ + "static/media/bg-pattern-header.527b53d3.svg";